<script setup>
const props = defineProps({
    leaves: {
        type: Array,
    },
    iconMap: {
        type: Object
    }
})

const emit = defineEmits(['delete', 'show'])

function show(id){
    emit('show', id)
}

function formatTime(datetime){
    return dayjs(datetime).format('HH:mm')
}

function formatDate(datetime){
    return dayjs(datetime).format('DD')
}

</script>


<template>
    <table v-if="leaves.length" class="table-auto w-full overflow-auto border-separate ">
        <thead>
        <tr>
            <th>date</th>
            <th>begin</th>
            <th>end</th>
            <th>hours</th>
            <th>type</th>
            <th>status</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="leave in leaves">
            <tr class="text-center hover:bg-gray-200">
                <td><div class="rounded-full bg-indigo-400 text-white">{{formatDate(leave.begin_time)}}</div></td>
                <td>{{formatTime(leave.begin_time)}}</td>
                <td>{{formatTime(leave.end_time)}}</td>
                <td>{{ leave.leave_hours }}</td>
                <td>{{ leave.leave_type }}</td>
                <td>{{ iconMap[leave.status] }}</td>
                <td><button @click="show(leave.id)">🔍</button></td>
            </tr>
        </template>
        </tbody>
    </table>
    <div v-else class="text-center">no data, please try other conditions</div>

</template>
